import { useQueryClient } from "@tanstack/react-query";
import { Delivery } from "../../../../services/Delivery";

export const useDeliveryCidadesLista = () => {
  const queryClient = useQueryClient();

  const buscarCidades = () => {
    return queryClient
      .fetchQuery({
        queryKey: ["delivery-cidades-lista"],
        queryFn: () => Delivery.get({ page: 0, size: 100 }),
      })
      .then(({ data }) =>
        Array.from(new Set(data.content.map((item) => item.cidade))),
      );
  };

  return { buscarCidades };
};
